// import s from '../allservices.jsx'
import { toast } from 'react-toastify';

const getCardDetailService = (actionCallback, cardRefNo) => {
    let token = "Token " + localStorage.getItem('token')
    let baseUrl= localStorage.getItem('serviceUrl')
    fetch(baseUrl +"/rest/card/detailsByCardReferenceId/"  + cardRefNo , {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
        })
    })
        .then(res => {
            if (res.status === 200 ) {
                if(localStorage.getItem('cardSearchToast')=== 'first'){
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('cardSearchToast','second')
                }
                
                res.json().then(json => actionCallback(json, "success"))
            } 
            else if(res.status === 401){
                actionCallback("401", "sessionout")
                this.props.history.push('/SessionOut')
            }
            else {
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });  
                actionCallback("no body", "error")
            }
        })
}

export default getCardDetailService;


// WEBPACK FOOTER //
// ./src/services/components/card_detail_service.jsx